module.exports = __webpack_public_path__ + "img/drum.be5030ca.webp";